/* CR47 sold-out capture: follows the selected variant using Sense's variant-change event.
   No request of its own. Degrades to the server-rendered state without JavaScript. */
(() => {
  if (window.__nmRestock) return;
  window.__nmRestock = true;
  const slug = (s) => String(s || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  const sizeOf = (variant) => {
    if (!variant) return '';
    const i = (variant.options || []).length && window.__nmSizeIndex != null ? window.__nmSizeIndex : -1;
    return i >= 0 ? variant.options[i] : variant.title;
  };
  const apply = (sectionId, variant) => {
    const box = document.getElementById(`NmRestock-${sectionId}`);
    if (!box || !variant) return;
    const size = sizeOf(variant);
    box.hidden = !!variant.available;
    // The dispatch promise above the button only applies to a buyable variant.
    document.querySelectorAll('[data-nm-buy-top] .nm-dispatch:not(.nm-dispatch--pre)').forEach((el) => { el.hidden = !variant.available; });
    box.querySelectorAll('[data-nm-restock-size]').forEach((el) => { el.textContent = size; });
    const tags = box.querySelector('[data-nm-restock-tags]');
    const handle = box.dataset.handle;
    if (tags) tags.value = `nm-restock,${handle},${handle}-${slug(size)}`;
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest('[data-nm-open]');
    if (!a) return;
    const d = document.getElementById(a.getAttribute('data-nm-open'));
    if (d && d.tagName === 'DETAILS') { d.open = true; }
  });
  const start = () => {
    // Find which product option is "Size" from the variant picker legends, if present.
    document.querySelectorAll('variant-selects fieldset legend').forEach((lg, i) => {
      if (/^\s*size\b/i.test(lg.textContent)) window.__nmSizeIndex = i;
    });
    // constants.js declares PUB_SUB_EVENTS with const, so it is a global binding but not a window property.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
        if (e && e.data) apply(e.data.sectionId, e.data.variant);
      });
    }
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
